import React from 'react';
import { connect } from 'react-redux';
import { getFormattedDateTimeByLocale } from '@treelab/panda';

import { IRootState } from '../../../../modules/stores';
import { isAbsentCellValue } from '../../../../helpers';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string;
}

const WithFieldId: React.FC<IProps & IConnectProps> = ({ cell, field, locale }) => {
  if (isAbsentCellValue(cell)) return null;

  const time = getFormattedDateTimeByLocale(cell, field.typeOptions, locale);
  return <span>{(!!time && time) || ''}</span>;
};

const mapState = ({ core }: IRootState, { recordId, fieldId }: IProps) => ({
  cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
  field: core.fieldById[fieldId],
  locale: core.locale,
});

export default {
  WithFieldId: connect(mapState)(WithFieldId),
};
